import { render, staticRenderFns } from "./home-donor-info-card.vue?vue&type=template&id=dc6168b6&"
import script from "./home-donor-info-card.vue?vue&type=script&lang=js&"
export * from "./home-donor-info-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports